export var dataSelectorId = {
    main: 'nested-navigation',
    itemStringPartId: 'nested-navigation-item'
};
//# sourceMappingURL=helpers.js.map